module.exports = __webpack_public_path__ + "img/registration-1.31b6c59.jpg";